// Configuration de l'API
const API_CONFIG = {
  // URL de base de l'API Laravel (avec /api)
  BASE_URL: process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/api` : `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000'}/api`,

  // Timeout pour les requêtes (en millisecondes)
  TIMEOUT: 10000,

  // Endpoints de l'API
  ENDPOINTS: {
    // Dashboard
    DASHBOARD_STATS: '/admin/dashboard/stats',
    RECENT_ORDERS: '/admin/orders/recent',
    TOP_PRODUCTS: '/admin/products/top',

    // Gestion des données
    SUPPLIERS: '/admin/suppliers',
    DELIVERY: '/admin/delivery',
    PRODUCTS: '/admin/products',
    ORDERS: '/admin/orders',
    USERS: '/admin/users',
    CATEGORIES: '/admin/categories',

    // Recherche
    SEARCH: '/admin/search',

    // Authentification
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    PROFILE: '/auth/profile',
  },

  // Configuration des headers par défaut
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
};

export default API_CONFIG;




